import type { PendingCorrection } from './reconcile'

// Result rows returned by the batch backend functions. Kept in sync with the
// DB functions' return columns.
export type BatchApplyResult = {
  correction_id: string
  outcome: string // 'applied' | 'refused'
  detail: string | null
  shift_date: string | null
  from_value: string | null
  to_value: string | null
  correction_type: string | null
}

export type BatchCloseResult = {
  correction_id: string
  outcome: string // 'closed' | 'refused'
  detail: string | null
}

// Live summary shape from previewCorrectionBatch.
export type BatchPreview = {
  total_selected: number
  minor_count: number
  material_count: number
  selectable_count: number
  blocked_count: number
  owners_affected: number
  owner_money_moved_zar: number
}

// A correction can only be batch-applied when it is neither stale nor
// conflicting. Both states guarantee a refusal, so their checkboxes are
// disabled and they are excluded from select-all.
export function isSelectable(row: PendingCorrection): boolean {
  return row.is_stale !== true && row.would_conflict !== true
}

// Format a Rand amount for the material warning sentence: thousands grouped
// with a comma, no decimals — e.g. 15615 -> "R15,615".
export function formatMoney(v: number): string {
  const safe = Number.isFinite(v) ? v : 0
  return 'R' + Math.round(safe).toLocaleString('en-US')
}

// The exact material warning sentence, with the live owners/money figures
// substituted in. Wording is fixed by product and must not be paraphrased.
export function materialWarning(ownersAffected: number, moneyMoved: number): string {
  return `Material corrections move revenue between vehicle owners. This selection affects ${ownersAffected} owners and moves ${formatMoney(moneyMoved)}. The drivers' pay is unaffected. Owner statements for the affected periods will need regenerating.`
}
